export default __webpack_public_path__ + "static/media/icon-skip.1966e3c8.svg";